export default __webpack_public_path__ + "static/media/TheThing.5fad8823.mp3";